import PropTypes from "prop-types";
import { useMemo } from "react";
import { toast } from "sonner";
import { z } from "zod";

import { BaseForm, FormInput } from "components/BaseForm";
import { useGroupsMutations } from "hooks/useGroupsTable";

const schema = z.object({
  name: z.string().min(1, "Name is required"),
});

const GroupForm = ({ model, onSuccess }) => {
  const isEdit = !!model?.id;
  const { create, update } = useGroupsMutations();

  const defaults = useMemo(() => ({ name: model?.name ?? "" }), [model]);

  // `internal` has no input, but the API still expects it, so the stored value
  // is sent back unchanged.
  const handleSubmit = async ({ name }) => {
    const data = { name, internal: model?.internal || false };
    if (isEdit) {
      await update.mutateAsync({ id: model.id, data });
    } else {
      await create.mutateAsync(data);
    }
  };

  const handleSuccess = () => {
    toast.success(isEdit ? "Group updated" : "Group created");
    onSuccess?.();
  };

  return (
    <BaseForm
      schema={schema}
      defaultValues={defaults}
      onSubmit={handleSubmit}
      onSuccess={handleSuccess}
      submitButtonText="Save"
    >
      <FormInput name="name" label="Name" required />
    </BaseForm>
  );
};

GroupForm.propTypes = {
  model: PropTypes.object,
  onSuccess: PropTypes.func,
};

export default GroupForm;
